export enum BaseButtonSizeEnum {
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xs = 'xs',
  mini = 'mini',
  tiny = 'tiny'
}
